export default function DebtSection() {
  const protections = [
    {
      title: '第三者からの借り入れ等は存在しない',
      icon: 'ri-shield-check-line',
      color: 'from-emerald-500 to-teal-500'
    },
    {
      title: 'もし契約日以前の債務が発覚した場合、売主が弁済する',
      icon: 'ri-hand-coin-line',
      color: 'from-teal-500 to-cyan-500'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-red-50 rounded-full mb-6">
            <i className="ri-alert-line text-red-600 text-xl mr-3"></i>
            <span className="text-red-600 text-sm font-bold">IMPORTANT</span>
          </div>
          <h2 className="text-5xl font-black text-gray-900 mb-6">
            簿外債務、借金や負債への<span className="bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent">対応</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ご注意事項
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          {/* Main Assurance */}
          <div className="bg-gradient-to-br from-emerald-500 to-teal-500 rounded-3xl p-12 text-white mb-12 shadow-2xl">
            <div className="flex items-center justify-center mb-6">
              <div className="w-20 h-20 bg-white/20 backdrop-blur-md rounded-2xl flex items-center justify-center">
                <i className="ri-shield-check-line text-5xl text-white"></i>
              </div>
            </div>
            <h3 className="text-3xl font-black text-center mb-6">
              基本的に、弊社でお取り扱いしている法人は<br />簿外債務や負債等はございません
            </h3>
            <p className="text-xl text-center leading-relaxed text-white/90">
              特別な条件がある場合は、その旨を案件情報として明記しております。
            </p>
          </div>

          {/* Details */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-3xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-500">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-exchange-line text-3xl text-white"></i>
              </div>
              <h4 className="text-2xl font-black text-gray-900 mb-4">代表者からの借入・貸付</h4>
              <p className="text-gray-600 leading-relaxed">
                放棄または譲渡して頂くこととなっております。
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-500">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-file-shield-2-line text-3xl text-white"></i>
              </div>
              <h4 className="text-2xl font-black text-gray-900 mb-4">第三者からの借入</h4>
              <p className="text-gray-600 leading-relaxed">
                契約書に下記内容を盛り込んでおります。
              </p>
            </div>
          </div>

          {/* Contract Terms */}
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-10 border-2 border-teal-200 mb-12">
            <h4 className="text-2xl font-black text-gray-900 mb-8 text-center">契約書に盛り込まれる内容</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {protections.map((protection, index) => (
                <div
                  key={index}
                  className="flex items-start bg-white rounded-2xl p-6 border border-gray-200"
                >
                  <div className={`w-12 h-12 bg-gradient-to-br ${protection.color} rounded-xl flex items-center justify-center mr-4 flex-shrink-0`}>
                    <i className={`${protection.icon} text-2xl text-white`}></i>
                  </div>
                  <p className="text-gray-700 font-bold leading-relaxed">
                    {protection.title}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Contact CTA */}
          <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-10 border border-teal-200">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-question-answer-line text-3xl text-white"></i>
              </div>
              <h4 className="text-2xl font-black text-gray-900 mb-4">ご心配な点やご質問等ございましたら</h4>
              <p className="text-gray-700 leading-relaxed mb-6">
                お問い合わせいただければご説明させていただきます
              </p>
              <a
                href="mailto:info@nextage.jp"
                className="inline-flex items-center px-10 py-5 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-full font-bold text-lg hover:shadow-2xl hover:shadow-teal-500/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                お問い合わせ
                <i className="ri-mail-line ml-3"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
